import $ from 'jquery';
import * as jcf from 'jcf/dist/js/jcf';

$(document).ready(() => {

    let backupDeliveryPointsEmotors = '';
    let backupDeliveryPointsCarrier = '';
    let backupDeliveryPointsEmotorsExport = '';
    let backupDeliveryPointsCarrierExport = '';

    $(document).on('change', 'input[type="checkbox"].chkServices', ev => {
        const $this = $(ev.currentTarget);
        const nameInput = $this.closest('label').find('h6').text().toLowerCase();

        // Si l'utilisateur clique sur un service de type "export"
        if (nameInput.indexOf('export') !== -1) {

            // C'est la première fois que l'utilisateur clique sur le service export.
            // On va donc chercher la liste des points de livraison export, on l'enregistre, et on l'affiche.
            if (backupDeliveryPointsEmotors === '') {
                backupDeliveryPointsEmotors = $('#selectDeliveryPointEmotors').html();
                backupDeliveryPointsCarrier = $('#selectDeliveryPointCarrier').html();

                $.ajax({
                    url: $this.data('ajax-url'),
                    data: {
                        coefficientCar: $this.data('coefficient'),
                        typeDelivery: 'export',
                        typeCar: $this.data('car-type')
                    },
                    success: data => {
                        if ((typeof data === 'object') && (data !== null)) {

                            backupDeliveryPointsEmotorsExport = buildDeliveryOptions(data.deliveryPointsEMotors);
                            backupDeliveryPointsCarrierExport = buildDeliveryOptions(data.deliveryPointsCarrier);

                            displayExportMode(backupDeliveryPointsEmotorsExport, backupDeliveryPointsCarrierExport);

                        }
                    }
                });

            // Pas besoin de repasser par l'api
            } else {
                if ($this.is(':checked')) {
                    displayExportMode(backupDeliveryPointsEmotorsExport, backupDeliveryPointsCarrierExport);
                } else {
                    displayNotExportMode(backupDeliveryPointsEmotors, backupDeliveryPointsCarrier);
                }
            }
        }
    });
});

/**
 * Construit la liste des Option à partir de la liste des points de livraison
 *
 * @param deliveryPoints Liste des points de livraison
 */
function buildDeliveryOptions(deliveryPoints) {
    let options = '';

    for (let deliveryPoint of deliveryPoints) {
        options += `<option value="${deliveryPoint.id}" data-price="${deliveryPoint.price}">` +
            (deliveryPoint.department !== '' ? `${deliveryPoint.department} - ` : '') +
            deliveryPoint.city +
            ` (${deliveryPoint.price} €)` +
            '</option>';
    }

    return options;
}

/**
 * Met à jour la page HTML avec le mode forfait export activé.
 *
 * @param deliveryPointsEmotors Liste des points de livraison E-Motors
 * @param deliveryPointsCarrier Liste des points de livraison par transporteur
 */
function displayExportMode(deliveryPointsEmotors, deliveryPointsCarrier) {
    $('#containerDeliveryModeExpedicar, #containerDeliveryModeExpedicarQuotation').addClass('hide');

    updateDeliveryPoints(deliveryPointsEmotors, deliveryPointsCarrier);
    selectEMotorsDeliveryModeIfNotSelected();
}

/**
 * Met à jour la page HTML avec le mode forfait export non activé.
 *
 * @param deliveryPointsEmotors Liste des points de livraison E-Motors
 * @param deliveryPointsCarrier Liste des points de livraison par transporteur
 */
function displayNotExportMode(deliveryPointsEmotors, deliveryPointsCarrier) {
    $('#containerDeliveryModeExpedicar, #containerDeliveryModeExpedicarQuotation').removeClass('hide');

    updateDeliveryPoints(deliveryPointsEmotors, deliveryPointsCarrier);
    selectEMotorsDeliveryModeIfNotSelected();
}

/**
 * Met à jour les listes des points de livraison.
 *
 * @param deliveryPointsEmotors Liste des points de livraison E-Motors
 * @param deliveryPointsCarrier Liste des points de livraison par transporteur
 */
function updateDeliveryPoints(deliveryPointsEmotors, deliveryPointsCarrier) {
    $('#selectDeliveryPointEmotors, #selectDeliveryPointEmotorsQuotation').html(deliveryPointsEmotors);
    jcf.refresh('#selectDeliveryPointEmotors, #selectDeliveryPointEmotorsQuotation');

    $('#selectDeliveryPointCarrier, #selectDeliveryPointCarrierQuotation').html(deliveryPointsCarrier);
    jcf.refresh('#selectDeliveryPointCarrier, #selectDeliveryPointCarrierQuotation');
}

/**
 * Sélectionne le mode de livraison en agence s'il n'est pas déjà sélectionné.
 */
function selectEMotorsDeliveryModeIfNotSelected() {
    const withEmotors = $('#withEmotors');

    if (!withEmotors.is(':checked')) {
        $('#withEmotors, #withEmotorsQuotation').click();
    }
}
